/*! @pentacode/ui v0.1.0 */
import { _ as e } from "./shared-CfvkKPnq.js";
import { b as t, d as n, f as r, g as i, l as a, m as o, p as s, v as c, w as l, x as u } from "./guide-layout-CM2GPEJu.js";
import { a as d, i as f } from "./rule-BbeXdbtC.js";
// ../../node_modules/.pnpm/internmap@2.0.3/node_modules/internmap/src/index.js
var p = class extends Map {
	constructor(e, t = _) {
		if (super(), Object.defineProperties(this, {
			_intern: { value: /* @__PURE__ */ new Map() },
			_key: { value: t }
		}), e != null) for (let [t, n] of e) this.set(t, n);
	}
	get(e) {
		return super.get(m(this, e));
	}
	has(e) {
		return super.has(m(this, e));
	}
	set(e, t) {
		return super.set(h(this, e), t);
	}
	delete(e) {
		return super.delete(g(this, e));
	}
};
function m({ _intern: e, _key: t }, n) {
	let r = t(n);
	return e.has(r) ? e.get(r) : n;
}
function h({ _intern: e, _key: t }, n) {
	let r = t(n);
	return e.has(r) ? e.get(r) : (e.set(r, n), n);
}
function g({ _intern: e, _key: t }, n) {
	let r = t(n);
	return e.has(r) && (n = e.get(r), e.delete(r)), n;
}
function _(e) {
	return typeof e == "object" && e ? e.valueOf() : e;
}
// ../../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/range.js
function v(e, t, n) {
	e = +e, t = +t, n = (i = arguments.length) < 2 ? (t = e, e = 0, 1) : i < 3 ? 1 : +n;
	for (var r = -1, i = Math.max(0, Math.ceil((t - e) / n)) | 0, a = Array(i); ++r < i;) a[r] = e + r * n;
	return a;
}
// ../../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/ordinal.js
var y = Symbol("implicit");
function b() {
	var t = new p(), n = [], r = [], i = y;
	function a(e) {
		let a = t.get(e);
		if (a === void 0) {
			if (i !== y) return i;
			t.set(e, a = n.push(e) - 1);
		}
		return r[a % r.length];
	}
	return a.domain = function(e) {
		if (!arguments.length) return n.slice();
		n = [], t = new p();
		for (let r of e) t.has(r) || t.set(r, n.push(r) - 1);
		return a;
	}, a.range = function(e) {
		return arguments.length ? (r = Array.from(e), a) : r.slice();
	}, a.unknown = function(e) {
		return arguments.length ? (i = e, a) : i;
	}, a.copy = function() {
		return b(n, r).unknown(i);
	}, e.apply(a, arguments), a;
}
// ../../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/band.js
function x() {
	var t = b().unknown(void 0), n = t.domain, r = t.range, i = 0, a = 1, o, s, c = !1, l = 0, u = 0, d = .5;
	delete t.unknown;
	function f() {
		var e = n().length, t = a < i, f = t ? a : i, p = t ? i : a;
		o = (p - f) / Math.max(1, e - l + u * 2), c && (o = Math.floor(o)), f += (p - f - o * (e - l)) * d, s = o * (1 - l), c && (f = Math.round(f), s = Math.round(s));
		var m = v(e).map(function(e) {
			return f + o * e;
		});
		return r(t ? m.reverse() : m);
	}
	return t.domain = function(e) {
		return arguments.length ? (n(e), f()) : n();
	}, t.range = function(e) {
		return arguments.length ? ([i, a] = e, i = +i, a = +a, f()) : [i, a];
	}, t.rangeRound = function(e) {
		return [i, a] = e, i = +i, a = +a, c = !0, f();
	}, t.bandwidth = function() {
		return s;
	}, t.step = function() {
		return o;
	}, t.round = function(e) {
		return arguments.length ? (c = !!e, f()) : c;
	}, t.padding = function(e) {
		return arguments.length ? (l = Math.min(1, u = +e), f()) : l;
	}, t.paddingInner = function(e) {
		return arguments.length ? (l = Math.min(1, e), f()) : l;
	}, t.paddingOuter = function(e) {
		return arguments.length ? (u = +e, f()) : u;
	}, t.align = function(e) {
		return arguments.length ? (d = Math.max(0, Math.min(1, e)), f()) : d;
	}, t.copy = function() {
		return x(n(), [i, a]).round(c).paddingInner(l).paddingOuter(u).align(d);
	}, e.apply(f(), arguments);
}
// ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/rect-radius-state-internal.js
function S(e) {
	return e?.some(({ style: e }) => {
		let t = e.radius;
		return typeof t == "function" || Array.isArray(t);
	}) ?? !1;
}
function C(e, t) {
	return e === void 0 ? t ? { cornerRadii: [
		0,
		0,
		0,
		0
	] } : {} : typeof e == "number" ? t ? { cornerRadii: [
		e,
		e,
		e,
		e
	] } : { radius: e } : { cornerRadii: e };
}
// ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/scene-motion-internal.js
var w = /* @__PURE__ */ Symbol("scene-motion-node");
// ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/stack-ends-internal.js
function T(e, t, n, r, i, a = {}, o = "value") {
	let s = O(e, t, n, r, i, o), c = k(s, a.order);
	a.reverse && c.reverse();
	let l = new Map(c.map((e, t) => [u(e), t])), d = [...s].sort((e, t) => l.get(u(e.series)) - l.get(u(t.series))), f = Array.from({ length: e.length }), p = E(s), m = E(d), h = a.offset === void 0 || a.offset === "diverging";
	for (let [e, t] of m) {
		let n = p.get(e);
		if (h) {
			let e = Math.min(...t.flatMap((e) => [e.start, e.end]));
			Math.max(...t.flatMap((e) => [e.start, e.end])) > 0 && D(t, n, "max", f), e < 0 && D(t, n, "min", f);
		} else {
			let e = t[0].start, r = t.at(-1).end, i;
			if (r < e) i = "min";
			else if (r > e) i = "max";
			else {
				let n = Math.min(...t.flatMap((e) => [e.start, e.end])), r = Math.max(...t.flatMap((e) => [e.start, e.end]));
				i = e - n > r - e ? "min" : "max";
			}
			D(t, n, i, f);
		}
	}
	return f;
}
function E(e) {
	let t = /* @__PURE__ */ new Map();
	for (let n of e) {
		if (n.value === 0 || n.start === n.end) continue;
		let e = u(n.position), r = t.get(e);
		r ? r.push(n) : t.set(e, [n]);
	}
	return t;
}
function D(e, t, n, r) {
	if (e.length === 0) return;
	let i = Math[n](...e.flatMap((e) => [e.start, e.end]));
	for (let e of t) {
		let t = e.start === i, n = e.end === i;
		if (!t && !n) continue;
		let a = r[e.index];
		r[e.index] = {
			start: a?.start === !0 || t,
			end: a?.end === !0 || n
		};
	}
}
function O(e, t, n, r, i, a) {
	let o = [];
	for (let s = 0; s < e.length; s += 1) {
		let c = e[s], l = t[s], u = r[s], d = i[s];
		if (!j(c) || !M(l) || !M(u) || !M(d)) continue;
		let f = n[s];
		o.push({
			index: s,
			position: c,
			value: l,
			start: u,
			end: d,
			series: A(f) ? f : a === "index" ? s : "value"
		});
	}
	return o;
}
function k(e, t) {
	let n = [], r = /* @__PURE__ */ new Set();
	for (let t of e) {
		let e = u(t.series);
		r.has(e) || (r.add(e), n.push(t.series));
	}
	if (Array.isArray(t)) {
		let e = [...t], r = new Set(e.map(u));
		return [...e, ...n.filter((e) => !r.has(u(e)))];
	}
	if (t === "inside-out") {
		let t = [], r = /* @__PURE__ */ new Map();
		for (let n of e) {
			let e = u(n.position);
			r.has(e) || (r.set(e, t.length), t.push(n.position));
		}
		let i = n.map((n) => {
			let i = u(n), a = t.map(() => [0, 0]);
			for (let t of e) u(t.series) === i && (a[r.get(u(t.position))][1] = t.value);
			return a;
		});
		return d(i).map((e) => n[e]);
	}
	if (t !== "ascending" && t !== "descending") return n;
	let i = new Map(n.map((e) => [u(e), 0]));
	for (let t of e) {
		let e = u(t.series);
		i.set(e, (i.get(e) ?? 0) + Math.abs(t.value));
	}
	return n.sort((e, n) => {
		let r = (i.get(u(e)) ?? 0) - (i.get(u(n)) ?? 0);
		return t === "ascending" ? r : -r;
	});
}
function A(e) {
	return typeof e == "string" || typeof e == "number";
}
function j(e) {
	return typeof e == "string" || M(e) || e instanceof Date && Number.isFinite(e.getTime());
}
function M(e) {
	return typeof e == "number" && Number.isFinite(e);
}
// ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/bar.js
function N(e, l = {}) {
	let d = Array.isArray(e) ? e : Array.from(e), p = l.xScale ?? "x", m = l.yScale ?? "y", h = typeof l.radius == "function" || S(l.states);
	return n(({ markIndex: e }) => {
		let n = l.id ?? `bar-y-${e}`, g = a(d, l.x, (e, { index: t }) => t), _ = H(d, l.y ?? l.y2, (e) => typeof e == "number" ? e : void 0), v = a(d, l.z, () => null), y = l.color === void 0 ? v : a(d, l.color, () => null), b = l.z === void 0 && l.color !== void 0 ? y : v, x = l.y1 !== void 0 || l.y2 !== void 0;
		if (x && l.layout?.type === "stack") throw TypeError("A bar with explicit y1 or y2 endpoints cannot also configure a stack layout");
		let S = l.layout?.type === "group";
		P(l.radius, x, S, "y");
		let C = l.layout?.type === "stack" ? l.layout : void 0, E = I(l.radius) ? l.radius : void 0, D = C?.offset === void 0 || C.offset === "diverging", O = !x && !S ? f(g, _, b, C, "index") : void 0, k = O && E && (E.stack ?? "outer") === "outer" ? T(g, _, b, O.starts, O.ends, C, "index") : void 0, A = x ? H(d, l.y1, () => 0) : O?.starts ?? d.map(() => 0), j = x ? H(d, l.y2 ?? l.y, () => void 0) : S ? _ : O.ends, M = B(g), N = S || !x && M ? b : v, L = r(d, l.key, {
			groups: N,
			candidates: [g],
			markId: n,
			warningIdentity: l
		});
		return {
			id: n,
			states: i(d, l.states),
			seriesFromColor: l.z === void 0 && l.color !== void 0 && (S || M),
			channels: {
				x: {
					scale: p,
					values: g.filter(s)
				},
				y: {
					scale: m,
					values: [...j.filter(o), ...A.filter(o)],
					includeZero: l.y1 === void 0
				},
				color: {
					scale: "color",
					values: y.filter(t)
				}
			},
			render: ({ scales: e, chart: t, color: r }) => {
				let i = e[p].bandwidth || V(e[p], g, t.width, d.length), a = z(l.layout?.type === "group" ? l.layout : void 0, N, i), f = a?.bandwidth ?? i, v = R(f, l.inset, l.maxThickness), b = [];
				return d.forEach((t, x) => {
					let S = g[x], C = _[x], T = A[x], E = j[x];
					if (!s(S) || !o(C) || !o(T) || !o(E)) return;
					let M = N[x] ?? null, P = a?.map(M) ?? 0, I = r(y[x]), R = c(l.fill, t, x, d, I), z = c(l.stroke, t, x, d, "none"), B = c(l.strokeDasharray, t, x, d, "none"), V = e[p].map(S), H = e[m].map(T), U = e[m].map(E), W = O && D && C < 0 ? "start" : "end", G = W === "start" ? H : U, K = W === "start" ? U : H, q = k?.[x], J = V - i / 2 + P + v.inset, Y = Math.min(H, U), X = v.size, Z = Math.abs(H - U), Q = `${n}:${u(M)}:${u(L[x])}`, $ = F(l.radius, t, x, d, "y", G, K, k !== void 0, q, H, U, h), ee = {
						key: Q,
						markId: n,
						group: M,
						groupLabel: M == null ? n : String(M),
						datum: t,
						datumIndex: x,
						xValue: S,
						yValue: C,
						y1Value: T,
						y2Value: E,
						yInterval: "difference",
						x: V - i / 2 + P + f / 2,
						y: G,
						color: R
					}, te = {
						kind: "rect",
						key: Q,
						x: J,
						y: Y,
						width: X,
						height: Z,
						...$,
						inset: v.inset,
						insetAxis: "x",
						...v.maximum === void 0 ? {} : { maxThickness: v.maximum },
						interaction: {
							point: ee,
							affinity: "x"
						},
						style: {
							fill: R,
							fillOpacity: l.fillOpacity,
							stroke: z,
							strokeOpacity: l.strokeOpacity,
							strokeWidth: l.strokeWidth,
							strokeDasharray: B
						},
						[w]: { bar: { baseline: K } }
					};
					b.push(te);
				}), { nodes: [{
					kind: "group",
					key: n,
					className: "ts-chart__bar ts-chart__bar-y",
					ariaHidden: !0,
					children: b
				}] };
			}
		};
	}, l.motion, l.renderer);
}
function P(e, t, n, r) {
	if (I(e) && e.stack === "outer") {
		if (t) throw TypeError(`Bar radius stack "outer" requires an implicit ${r} extent`);
		if (n) throw TypeError("Bar radius stack \"outer\" cannot be used with a group layout");
	}
}
function F(e, t, n, r, i, a, o, s, l, u, d, f) {
	if (e === void 0) return C(void 0, f);
	if (I(e)) {
		let f = c(e.end, t, n, r, 0);
		if (a === o) return { cornerRadii: [
			0,
			0,
			0,
			0
		] };
		if (s) {
			if (!l) return { cornerRadii: [
				0,
				0,
				0,
				0
			] };
			if (l.start && l.end) return { cornerRadii: [
				f,
				f,
				f,
				f
			] };
			let e = l.start;
			return { cornerRadii: L(f, i, e ? u : d, e ? d : u) };
		}
		return { cornerRadii: L(f, i, a, o) };
	}
	return C(c(e, t, n, r, 0), f);
}
function I(e) {
	return typeof e == "object" && !!e && !Array.isArray(e);
}
function L(e, t, n, r) {
	return t === "y" ? n <= r ? [
		e,
		e,
		0,
		0
	] : [
		0,
		0,
		e,
		e
	] : n <= r ? [
		e,
		0,
		0,
		e
	] : [
		0,
		e,
		e,
		0
	];
}
function R(e, t, n) {
	let r = Math.max(0, t ?? 0), i = Math.max(0, e), a = Math.max(0, i - r * 2), o = Number.isFinite(n), s = o ? Math.max(0, n) : a, c = Math.min(a, s);
	return {
		inset: (i - c) / 2,
		maximum: o ? s : void 0,
		size: c
	};
}
function z(e, t, n) {
	if (!e) return;
	let r = l(e.scale ?? (() => x().padding(Number.isFinite(e.padding) ? Math.max(0, e.padding) : .1)), { values: t });
	r.range([0, n]);
	let i = r.bandwidth?.();
	if (i === void 0) throw TypeError("A grouped bar layout requires a D3 band scale");
	return {
		bandwidth: i,
		map(e) {
			if (e === null) throw TypeError("A grouped bar requires an explicit z channel or a discrete color channel");
			let t = r(e);
			if (t === void 0 || !Number.isFinite(t)) throw TypeError(`Bar group value "${String(e)}" is outside the group layout scale domain`);
			return t;
		}
	};
}
function B(e) {
	let t = /* @__PURE__ */ new Set();
	for (let n of e) {
		if (!s(n)) continue;
		let e = u(n);
		if (t.has(e)) return !0;
		t.add(e);
	}
	return !1;
}
function V(e, t, n, r) {
	let i = [...new Set(t.filter(s).map(e.map).filter((e) => Number.isFinite(e)))].sort((e, t) => e - t), a = Infinity;
	for (let e = 1; e < i.length; e += 1) a = Math.min(a, i[e] - i[e - 1]);
	return Number.isFinite(a) ? a * .8 : Math.min(48, n / Math.max(2, r + 1) * .8);
}
function H(e, t, n) {
	return typeof t == "number" ? e.map(() => t) : a(e, t, n);
}
export { N as t };

//# sourceMappingURL=bar-DYRrVa7n.js.map